<template>
  <div
    :class="$style['box']"
  >
    <div class="text-center mt-0 mb-10 sm:mb-20 font-vw-head px:0 sm:px-12">
      <h1
        :class="$style['title']"
      >
        El nuevo ID.7<br>
        <span class="font-light">ya está aquí</span>
      </h1>

      <p
        :class="$style['description']"
        class="px-0 sm:px-10"
      >
        Es primicia.<br>
        Es la nueva berlina 100% eléctrica.<br>
        Es toda la Familia ID.<br>
        Es la nueva calle del futuro de Volkswagen.<br>
        Podrás ver, tocar, conducir y descubrir.
      </p>
    </div>

    <div v-if="isMobile">
      <div class="p-10 z-10">
        <img
          src="@/assets/images/ciudad.png"
          class="w-full block"
        >
      </div>

      <div
        :class="$style['familiaid-bg']"
      >
        <p :class="$style['familiaid_description', 'description']">
          Lugar
        </p>
        <p
          class="mb-5 text-l font-vw-head"
        >
          Lugar Caleido. 4 Torres, Madrid. Paseo de la Castellana, 259E
        </p>
        <p :class="$style['familiaid_description', 'description']">
          Fecha
        </p>
        <p
          class="mb-5 text-l font-vw-head"
        >
          Del 17 al 19 de noviembre 2023
        </p>
      </div>

      <div class="text-center font-vw-head px-5 my-10">
        <span class="font-bold text-xl font-vw-head">Vente a dar una vuelta</span><br><br>
      </div>

      <div class="text-center mt-0 mb-0 font-vw-head px-12">
        <p
          :class="$style['description']"
          class="px-0 sm:px-10"
        >
          Acércate a dar una vuelta por ID. Street, entra en los locales temáticos ID., vive la gama 100% eléctrica de Volkswagen y te demostraremos que viajar en eléctrico es muy fácil.<br><br>
          Apúntate y asegúrate la entrada. Podrás elegir entre visita guiada por nuestros expertos con turno de horario cerrado, o entrada general con horario abierto para vivir la experiencia a tu manera.
        </p>
      </div>

      <div class="w-full py-10">
        <img
          src="@/assets/images/mapa_2_mobile.png"
          class="w-full block"
        >
      </div>

      <div class="text-center font-vw-head px-5 mb-20">
        <span class="font-bold text-xl font-vw-head">Descubre nuestros locales temáticos</span>
      </div>

      <div class="w-full mb-20">
        <img
          src="@/assets/images/grupo_IDHouse_mobile.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDDrive_mobile.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDCharge_mobile.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDTravel_mobile.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDBank_mobile.png"
          class="w-full block"
        >
      </div>
    </div>

    <div v-else>
      <div class="w-full mb-20">
        <img
          src="@/assets/images/ciudad_desktop.png"
          class="w-full block"
        >
      </div>

      <div class="text-center font-vw-head px-12 mb-10">
        <span class="font-bold text-xl font-vw-head">Vente a dar una vuelta</span><br><br>
      </div>

      <div class="text-center mt-0 mb-20 font-vw-head px-12">
        <p
          :class="$style['description']"
          class="px-0 sm:px-20"
        >
          Acércate a dar una vuelta por ID. Street, entra en los locales temáticos ID., vive la gama 100% eléctrica de Volkswagen y te demostraremos que viajar en eléctrico es muy fácil.<br><br>
          Apúntate y asegúrate la entrada. Podrás elegir entre visita guiada por nuestros expertos con turno de horario cerrado, o entrada general con horario abierto para vivir la experiencia a tu manera.
        </p>
      </div>

      <div class="w-full py-20">
        <img
          src="@/assets/images/mapa_2.png"
          class="w-full block"
        >
      </div>

      <div class="text-center font-vw-head px-12 mb-10">
        <span class="font-bold text-xl font-vw-head">Descubre nuestros locales temáticos</span><br><br>
      </div>

      <div class="w-full mb-20">
        <img
          src="@/assets/images/grupo_IDHouse.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDDrive.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDCharge.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDTravel.png"
          class="w-full block"
        >
      </div>

      <div class="w-full my-20">
        <img
          src="@/assets/images/grupo_IDBank.png"
          class="w-full block"
        >
      </div>
    </div>

    <div class="text-center mt-0 mb-10 sm:mb-20 font-vw-head px-5">
      <div class="w-full my-20">
        <iframe
          class="video-iframe"
          src="https://player.vimeo.com/video/875293058?h=8e5d685244"
          style="width: 100%; aspect-ratio: 16/9"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
        />
      </div>

      <h1
        :class="$style['title']"
      >
        ¡No te lo puedes perder!
      </h1>

      <p
        :class="$style['description']"
        class="px-0 sm:px-10"
      >
        Cómo has visto, tenemos un montón de cosas preparadas para que te sumerjas en una experiencia electrizante.<br>
        ¡Y muchas más sorpresas!
      </p>
    </div>

    <div
      class="text-center mt-10 font-vw-head px-12"
      id="signup"
    >
      <span class="font-bold text-xl font-vw-head">Elige tu plan y reserva tu entrada gratuita</span><br><br>
    </div>

    <div class="text-center">
      <a
        href="javascript:;"
        class="button-blue mt-10 md:mt-5 mx-5"
        @click="mostrarFormulario = true; entradaGuiada = true, scrollToId('signupForm')"
      >
        Entrada guiada
      </a>

      <a
        href="javascript:;"
        class="button-blue mt-10 md:mt-5 mx-5"
        @click="mostrarFormulario = true; entradaGuiada = false, scrollToId('signupForm')"
      >
        Entrada libre
      </a>
    </div>

    <div
      class="mt-20"
    >
      <SignUpForm
        v-if="mostrarFormulario"
        :guiada="entradaGuiada"
      />
    </div>
  </div>
</template>

<script>
import SignUpForm from '@c/SignUpForm'

export default {
  components: {
    SignUpForm
  },

  data () {
    return {
      mostrarFormulario: false,
      entradaGuiada: false
    }
  },

  props: {
    breakpoint: {
      type: Number,
      required: true
    }
  },

  computed: {
    isMobile () {
      return this.breakpoint < 672
    }
  },

  methods: {
    scrollToId (id) {
      this.$nextTick(() => {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      })
    }
  }
}
</script>

<style
  lang="scss"
  module
>
.box {
  max-width: 1200px;
  padding: 70px 0px 0px 0;
  @apply mx-auto;
}

.title {
  font-size: 32px;
  line-height: 36px;
  font-weight: 700;
  @apply font-vw-head;
  @apply mt-0;
  @apply mb-10;
}

.text {
  @apply text-center;
  @apply font-vw-head;
  @apply font-bold;
  @apply px-10;

  font-size: 32px;
  line-height: 36px;
}

.description {
  font-size: 18px;
  line-height: 28px;
}

.enlaces_mobile {
  margin-top: -60px;
}

.familiaid-bg {
  @apply bg-primary-blue;
  @apply text-white;
  @apply px-5;
  @apply z-0;

  padding-top: 90px;
  padding-bottom: 100px;
  margin-top: -80px;
  margin-bottom: 40px;
}

.familiaid {
  color: white;
  font-size: 24px;
  line-height: 28px;
}

.familiaid_description {
  color: white;
  font-size: 20px;
  line-height: 32px;
}

.conoce_el_equipo-bg {
  @apply bg-primary-blue;
  @apply text-white;
  @apply px-10;
  @apply z-0;

  padding-top: 150px;
  padding-bottom: 50px;
  margin-top: -130px;
}

.link {
  font-size: 18px;
  padding-bottom: 3px;
  border-bottom: 1px solid #001E50;
  &:hover {
    border-bottom: 1px solid #a9e3ff;
  }
}

@media (min-width: 576px) {
  .text {
    font-size: 36px;
    line-height: 40px;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 42px;
    line-height: 54px;
    font-weight: 700;
  }

  .text {
    font-size: 40px;
    line-height: 44px;
  }
}

@media (min-width: 960px) {
  .text {
    font-size: 44px;
    line-height: 50px;
  }
}
</style>
